import { AtMobile } from 'common/components/adaptive/mobile';
import React from 'react';
import { bottomLineStyles } from './styles';
import { RegularButton } from 'fronton-react';
import { ProductsBsCarousel } from './products-bs-carousel';
import type { ProductsCarouselComponentProps } from './types';
import type { Product } from 'common/components/product-card/types';
import { useTranslation } from 'react-i18next';
import { css } from 'linaria';

type ProductsCarouselBottomLineProps = ProductsCarouselComponentProps & {
  products: Product[];
  subtitle?: string;
  portalRootId?: string;
};

export const ProductsCarouselBottomLine = ({
  products,
  subtitle,
  slWidgetId,
  ratings,
  elementBlock,
  title,
  portalRootId,
}: ProductsCarouselBottomLineProps) => {
  const [showBs, setShowBs] = React.useState<boolean>(false);
  const showModalCb = React.useCallback(() => {
    setShowBs(true);
  }, [setShowBs]);

  const { t } = useTranslation();
  const seeAllButtonCaption = t('ui.button.see-all');

  const closeModalCb = React.useCallback(() => setShowBs(false), [setShowBs]);

  return (
    <AtMobile>
      <div className={elementBlock === 'TYP' ? bottomLineStylesWithMargin : bottomLineStyles}>
        <RegularButton size="l" data-qa="show-all-pdp" variant="secondary" wide onClick={showModalCb}>
          {seeAllButtonCaption}
        </RegularButton>
      </div>
      <ProductsBsCarousel
        products={products}
        subtitle={subtitle}
        slWidgetId={slWidgetId}
        ratings={ratings}
        elementBlock={elementBlock as string}
        show={showBs}
        onCloseIntent={closeModalCb}
        categoryTitle={title}
        portalRootId={portalRootId}
      />
    </AtMobile>
  );
};

const bottomLineStylesWithMargin = css`
  margin-bottom: var(--space-400);
`;
